import SystemTab from './SystemTab.vue';
export default SystemTab;
